import { useState } from "react";
import { FaArrowLeft, FaBars } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function QuemSomos() {
  const navigate = useNavigate();
  const [mostraMenu] = useState(true);

  return (
    <div className="w-full h-auto min-h-full flex flex-col text-[#133D6B] bg-slate-50 overflow-x-hidden">
      <div className="w-full h-[10vh] bg-[#133D6B] flex justify-between lg:justify-evenly pt-[1.25vh] px-[4vw] lg:px-[9vw]">
        <div className="hidden lg:flex justify-start w-1/3">
          <button
            className=" bg-[#5CC140] px-4 border-2 border-slate-100 text-slate-100
                    rounded-lg font-lato-bold flex gap-1 justify-center items-center h-3/4
                    hover:bg-slate-100 hover:border-[#5CC140] hover:text-[#5CC140]
                    transition text-[3vh]"
            onClick={() => navigate("/")}
          >
            <FaArrowLeft />
            Voltar
          </button>
        </div>
        <div className="flex justify-evenly lg:w-1/3 mt-[0.3vh]">
          <img src={"/logo-gradiente.png"} alt="logoCredor" style={{ height: "6.5vh" }}></img>
        </div>
        <div className="hidden lg:flex justify-end gap-6 w-1/3">
          <button
            className=" bg-[#5CC140] px-4 border-2 border-slate-100 text-slate-100
                    rounded-lg font-lato-bold flex gap-1 justify-center items-center h-3/4
                    hover:bg-slate-100 hover:border-[#5CC140] hover:text-[#5CC140]
                    transition text-[3vh]"
          >
            FAQ
          </button>
          <button
            className=" px-4 border-2 
                    rounded-lg font-lato-bold flex gap-1 justify-center items-center h-3/4
                    bg-slate-100 border-[#5CC140] text-[#5CC140]
                    transition text-[3vh]"
          >
            Quem Somos?
          </button>
        </div>
        <div className="text-white lg:hidden flex ">
          <button className="h-3/4 text-[4vh] justify-center items-center">
            <FaBars />
          </button>
        </div>
      </div>
      {mostraMenu && (
        <div className="lg:hidden fixed flex flex-col bg-white p-2 self-end mt-[8vh]">
          <div className="w-full">
            <button
              className="w-full text-left font-lato-bold hover:bg-slate-20 text-[#133D6B]
                        text-[3vh] "
            >
              FAQ
            </button>
          </div>
          <div className="w-full">
            <button
              className="w-full text-left font-lato-bold hover:bg-slate-20 text-[#133D6B]
                        text-[3vh]"
            >
              VOLTAR
            </button>
          </div>
          <div className="w-full">
            <button
              className="w-full text-left font-lato-bold hover:bg-slate-20 text-[#133D6B]
                        text-[3vh] "
            >
              QUEM SOMOS?
            </button>
          </div>
        </div>
      )}
      <div className="w-full flex justify-center h-full ">
        <div className="w-full lg:w-2/4 h-full lg:h-[90vh] flex flex-col text-justify bg-white px-10 ">
          <div className="text-center font-lato-bold mt-[5%] text-[#5CC140]">
            <h3>Quem Somos?</h3>
          </div>
          <div className="grid gap-6 mt-[2.5%] pb-4">
            <h6>
              A Pague Direto é uma Fintech nacional com soluções end-to-end em gestão e proteção de recebíveis,
              trabalhamos com relacionamento conectando o credor e o devedor, negociando dívidas e reduzindo a
              inadimplência nas empresas, reestabelecendo o poder de compra das famílias.
            </h6>
            <h6>Tudo isso através de uma plataforma digital que possui como diferenciais:</h6>
            <h6>
              Integração via API, elimina erros humanos e documentos físicos, atualização de valores, higienização de
              Base de Dados, comunicação inteligente e acolhedora, negociação fácil 100% digital, facilidade no
              pagamento e Split bancário{" "}
            </h6>
            <h6>
              Garanta uma gestão centralizada e efetiva da inadimplência, com menos papelada e mais assertividade na
              operação.
            </h6>
            <h6>Já encontramos e negociamos com devedores no mundo inteiro.</h6>
            <h6>BRASIL, ESTADOS UNIDOS, ITÁLIA, FINLÂNDIA, PORTUGAL, COREIA DO SUL e CANADÁ</h6>
            <h6>
              Vale lembrar que o sistema e toda a operação estão em acordo à nova LGPD (Lei Geral de Proteção de Dados)
            </h6>
          </div>
        </div>
        <div className="hidden lg:flex ">
          <img alt="pague-quem-somos" src={"/quem-somos-cover.jpg"} style={{ height: "90vh" }}></img>
        </div>
      </div>
    </div>
  );
}

export default QuemSomos;
